import { React, useMemo, useContext, FC, autoCommand } from 'external/react'
import {Button, styled} from 'external/material'
import {dayjs} from 'external/dayjs'
import {format} from 'external/date-fns'

import { TeacherContext } from 'teacher/context'

const StyledAddDailyPlanning = styled(Button)(addDailyPlannningStyles as any)

type AddDailyPlanningProps = {
  scrollToLastItem?: any
}

const AddDailyPlanning: FC<AddDailyPlanningProps> = props => {

  const {scrollToLastItem} = props

  const {newPlan: {start, finish, content}, translate, updateState} = useContext(TeacherContext) as any

  // We disregard the time so that the days are calculated correctly and allow planning for one day
  const differenceInDays = useMemo(() => {
    const startDate = dayjs(getDateString(start))
    const finishDate = dayjs(getDateString(finish))
    const dayDiff = finishDate.diff(startDate, 'days')
    return isNaN(dayDiff) ? 0 : dayDiff + 1
  }, [start, finish])

  const thereIsAvaliableDays = useMemo((() => (content?.dailyPlanning?.length ?? 0) < differenceInDays), [content, differenceInDays])

  function addDailyPlannning() {
      updateState({newPlan: autoCommand({$autoArray: {$push: [{}]}}, 'content', 'dailyPlanning')})
      scrollToLastItem && setTimeout(scrollToLastItem, 0)
  }

  return (
      <StyledAddDailyPlanning variant="contained" disabled={!thereIsAvaliableDays} className="planning-rd-add-daily-planning" onClick={addDailyPlannning}>
        + { translate(`plannind-rd-daily-planning-title`, {n: ''}) }
      </StyledAddDailyPlanning>
  )
}

export {AddDailyPlanning as default}

//Discards time info
function getDateString (str = 'T') {
  switch (typeof(str)) {
    case 'string': return str.split('T')[0]
    case 'object': return format(str, 'yyyy-MM-dd')
    default: return ''
  }
}

function addDailyPlannningStyles () {
  return{
    color: '#fff',
    background: '#2993ff',
    textTransform: 'none',
    '&:hover': {
      background: '#4e576e'
    }
  }
}